<script>
  import { onMount, tick } from 'svelte';
  import { DialogNew } from '@shopboxai/sb-portal-components';
  import { clientID } from '../../../utils';
  import { saveGridConfig } from '../../../api';
  export let data = {};
  let mounted;
  let currency;
  async function resetPreview() {
    mounted = false;
    await tick();
    await tick();

    mounted = true;
  }
  const saveConfig = async () => {
    console.log('save config before preview');
    mounted = false;
    await tick();
    await saveGridConfig(data.id, data.name, data.custom_css, true);
    await tick();
    mounted = true;

  };
</script>

<DialogNew on:submit on:close on:open={saveConfig} maxWidth="90vw">
  <button slot="toggle" class="primary">Preview grid </button>
  <div slot="content" class="wrapper">
    <select name="currency" id="" bind:value={currency} on:change={resetPreview}>
      <option value="EUR" selected>EUR</option>
      <option value="GBP">GBP</option>
    </select>
    <div style="transform:scale(0.8);display:flex;gap:2em;">
      {#if mounted}
        <script src="https://main.shopbox-grid.pages.dev/sbgrid.min.js"></script>
        <shopbox-grid id={data.id} cid={$clientID} {currency} preview="true" />

          <div class="device device-iphone-x">
            <div class="device-frame">
              <iframe title="mobile" class="device-content"  id="mobile" width="375" srcdoc="<html><body>   <script src='https://main.shopbox-grid.pages.dev/sbgrid.min.js'></script>   <shopbox-grid id='{data.id}' cid='{$clientID}' currency='{currency}' preview='true' mobilepreview='true' /></body></html>"></iframe>
            </div>
            <div class="device-stripe"></div>
            <div class="device-header"></div>
            <div class="device-sensors"></div>
            <div class="device-btns"></div>
            <div class="device-power"></div>
          </div>

      {/if}
    </div>
  </div>
  <div slot="header">Preview grid</div>
  <button class="primary" slot="primary-action">Save grid </button>
</DialogNew>

<style>.wrapper{max-height:70vh;min-height:400px;overflow-y:scroll}.loader{align-items:center;display:flex;justify-content:center}iframe{border:none;height:100%}.device,.device *,.device:after,.device :after,.device:before,.device :before{box-sizing:border-box;display:block}.device{position:relative;transform-origin:top center}.device,.device .device-frame{z-index:1}.device .device-content{background-color:#fff;background-position:50%;background-size:cover;-o-object-fit:cover;object-fit:cover;padding-top:10px;position:relative}.device-iphone-x{height:868px;transform:scale(.8);transform-origin:top center;width:428px}.device-iphone-x .device-frame{background:#222;border-radius:68px;box-shadow:inset 0 0 2px 2px #c8cacb,inset 0 0 0 7px #e2e3e4;height:868px;padding:28px;width:428px}.device-iphone-x .device-content{border-radius:40px;height:812px;width:375px}.device-iphone-x .device-stripe:after,.device-iphone-x .device-stripe:before{border:solid rgba(51,51,51,.25);border-width:0 7px;content:"";height:7px;left:0;position:absolute;width:100%;z-index:9}.device-iphone-x .device-stripe:after{top:85px}.device-iphone-x .device-stripe:before{bottom:85px}.device-iphone-x .device-header{background:#222;border-bottom-left-radius:20px;border-bottom-right-radius:20px;height:30px;left:50%;margin-left:-102px;position:absolute;top:28px;width:204px}.device-iphone-x .device-header:after,.device-iphone-x .device-header:before{content:"";height:10px;position:absolute;top:0;width:10px}.device-iphone-x .device-header:after{background:radial-gradient(circle at bottom left,transparent 0,transparent 75%,#222 0,#222 100%);left:-10px}.device-iphone-x .device-header:before{background:radial-gradient(circle at bottom right,transparent 0,transparent 75%,#222 0,#222 100%);right:-10px}.device-iphone-x .device-sensors:after,.device-iphone-x .device-sensors:before{content:"";position:absolute}.device-iphone-x .device-sensors:after{background:#444;border-radius:3px;height:6px;left:50%;margin-left:-25px;top:32px;width:50px}.device-iphone-x .device-sensors:before{background:#444;border-radius:50%;height:14px;left:50%;margin-left:40px;top:28px;width:14px}.device-iphone-x .device-btns{background:#c8cacb;height:32px;left:-3px;position:absolute;top:115px;width:3px}.device-iphone-x .device-btns:after,.device-iphone-x .device-btns:before{background:#c8cacb;content:"";height:62px;left:0;position:absolute;width:3px}.device-iphone-x .device-btns:after{top:60px}.device-iphone-x .device-btns:before{top:140px}.device-iphone-x .device-power{background:#c8cacb;height:100px;position:absolute;right:-3px;top:200px;width:3px}</style>
